import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  background-color: ${(props) => props.backgroundColor || "transparent"};
  color: ${(props) => props.textColor || "#B03D01"};
  border: 1px solid ${(props) => props.borderColor || "#B03D01"};
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  cursor: pointer;
`;

const ButtonText = styled.span`
  font-weight: 400;
  font-size: ${(props) => props.fontSize || "15px"};
  text-align: center;
  line-height: 14px;
  font-family:${(props) => props.fontFamily || "Archivo Regular"};
  text-transform: uppercase;
`;

const StyledOutlinedButton = ({
  backgroundColor,
  textColor,
  borderColor,
  width,
  height,
  onClick,
  text,
  fontFamily,
  fontSize,
}) => {
  return (
    <StyledButton
      backgroundColor={backgroundColor}
      textColor={textColor}
      borderColor={borderColor}
      fontFamily={fontFamily}
      width={width}
      height={height}
      onClick={onClick}
    >
      <ButtonText fontFamily={fontFamily} fontSize={fontSize}>{text}</ButtonText>
    </StyledButton>
  );
};

export default StyledOutlinedButton;
